import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getVFees as getVFeesApi,
  getVFeesGetFilters as getVFeesGetFiltersApi,
  getVFeesGetFiltersExport as getVFeesGetFiltersExportApi,
  getVFeesByClient as getVFeesByClientApi,
  getVFeesBalance as getVFeesBalanceApi,
  getVFeesBalanceClient as getVFeesBalanceClientApi,
  getVFeeByNumber as getVFeeByNumberApi,
  getVFeeFindByNumber as getVFeeFindByNumberApi,
  getVFeesCompany as getVFeesCompanyApi,
  getVFeesFindByID as getVFeesFindByIDApi,
  addNewVFee as addNewVFeeApi,
  updateVFee as updateVFeeApi,
  deleteVFee as deleteVFeeApi,
  lockUnlockVFees as lockUnlockVFeesApi,
  getVFeesDeleted as getVFeesDeletedApi,
} from "../../helpers/realbackend_helper";

export const getVFees = createAsyncThunk(
  "vfee/getVFees",
  async ({ beginDate, lastDate }, { rejectWithValue }) => {
    try {
      const response = await getVFeesApi(beginDate, lastDate);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch VFees");
    }
  }
);

export const getVFeesGetFilters = createAsyncThunk(
  "vfee/getVFeesGetFilters",
  async (filters, thunkAPI) => {
    try {
      const response = await getVFeesGetFiltersApi(filters);
      return response;
    } catch (error) {
      console.error("Error fetching containers:", error);
      return thunkAPI.rejectWithValue(
        error.response || error.message || "Error fetching containers"
      );
    }
  }
);

export const getVFeesGetFiltersExport = createAsyncThunk(
  "vfee/getVFeesGetFiltersExport",
  async (filters, thunkAPI) => {
    try {
      const response = await getVFeesGetFiltersExportApi(filters);
      return response;
    } catch (error) {
      console.error("Error fetching containers:", error);
      return thunkAPI.rejectWithValue(
        error.response || error.message || "Error fetching containers"
      );
    }
  }
);

export const getVFeesByClient = createAsyncThunk(
  "vfee/getVFeesByClient",
  async ({ beginDate, lastDate, company_name }, { rejectWithValue }) => {
    try {
      const response = await getVFeesByClientApi(
        beginDate,
        lastDate,
        company_name
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch VFees");
    }
  }
);

export const getVFeesBalance = createAsyncThunk(
  "vfee/getVFeesBalance",
  async ({ beginDate, lastDate }, { rejectWithValue }) => {
    try {
      const response = await getVFeesBalanceApi(beginDate, lastDate);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch VFees");
    }
  }
);

export const getVFeesBalanceClient = createAsyncThunk(
  "vfee/getVFeesBalanceClient",
  async ({ beginDate, lastDate, company_name }, { rejectWithValue }) => {
    try {
      const response = await getVFeesBalanceClientApi(
        beginDate,
        lastDate,
        company_name
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch VFees");
    }
  }
);

export const getVFeesCompany = createAsyncThunk(
  "vfee/getVFeesCompany",
  async ({ beginDate, lastDate, company_name }, { rejectWithValue }) => {
    try {
      const response = await getVFeesCompanyApi(
        beginDate,
        lastDate,
        company_name
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch VFees");
    }
  }
);

export const getVFeesFindByID = createAsyncThunk(
  "vfee/getVFeesFindByID",
  async (vfee) => {
    try {
      const response = await getVFeesFindByIDApi(vfee);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getVFeeByNumber = createAsyncThunk(
  "vfee/getVFeeByNumber",
  async (vfee) => {
    try {
      const response = await getVFeeByNumberApi(vfee);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getVFeeFindByNumber = createAsyncThunk(
  "vfee/getVFeeFindByNumber",
  async (vfee) => {
    try {
      const response = await getVFeeFindByNumberApi(vfee);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewVFee = createAsyncThunk("vfee/addNewVFee", async (vfee) => {
  try {
    const response = addNewVFeeApi(vfee);
    toast.success("Хураамжийн мэдээллийг амжилттай нэмлээ", {
      autoClose: 3000,
    });
    return response;
  } catch (error) {
    toast.error("Хураамжийн мэдээллийг бүртгэхэд алдаа гарлаа!", {
      autoClose: 3000,
    });
    return error;
  }
});

export const updateVFee = createAsyncThunk("vfee/updateVFee", async (vfee) => {
  try {
    const response = updateVFeeApi(vfee);
    toast.success("Хураамжийн мэдээллийг амжилттай засварлалаа", {
      autoClose: 3000,
    });
    return response;
  } catch (error) {
    toast.error("Хураамжийн мэдээллийг засварлахад алдаа гарлаа!", {
      autoClose: 3000,
    });
    return error;
  }
});

export const deleteVFee = createAsyncThunk(
  "vfee/deleteVFee",
  async (id, { rejectWithValue }) => {
    try {
      //console.log("Deleting ID:", id);
      await deleteVFeeApi(id); // e.g. DELETE /api/vfees/664...

      toast.success("Хураамжийн мэдээллийг амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id }; // ✅ return the ID to reducer
    } catch (error) {
      toast.error("Хураамжийн мэдээллийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);

export const lockUnlockVFees = createAsyncThunk(
  "vfee/lockUnlockVFees",
  async ({ beginDate, lastDate, command }, thunkAPI) => {
    try {
      const response = await lockUnlockVFeesApi({
        beginDate,
        lastDate,
        command,
      });

      toast.success(response.message, {
        autoClose: 3000,
      });

      return {
        message: response.message,
        beginDate,
        lastDate,
        command,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getVFeesDeleted = createAsyncThunk(
  "vfee/getVFeesDeleted",
  async ({ beginDate, lastDate }, { rejectWithValue }) => {
    try {
      const response = await getVFeesDeletedApi(beginDate, lastDate);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch VFees");
    }
  }
);
